export default __webpack_public_path__ + "a49e25acf439a84afac69ddaabbf4a71.svg";